function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { useTranslation } from 'react-i18next';
import { DatePicker, datesInChronologicalOrder, compareDate } from '@rd-web-markets/shared/dist/util/date';
import { TextFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';
import { Col, Row, Form } from 'react-bootstrap';
import elsterService from '../../services/company/elsters.service';
import { ELSTER_VERSION_7_CUTOFF } from '../../constants';

/** version_7 if end is before 01/01/2024, else version_8; default version_7 when no end date */
const getRecommendedElsterVersionNumber = _ref => {
  let {
    endDate
  } = _ref;
  if (!endDate) {
    return 'version_7';
  }
  return compareDate(endDate, ELSTER_VERSION_7_CUTOFF, 'before') ? 'version_7' : 'version_8';
};
const FinancialYearModal = _ref2 => {
  var _elster$version_numbe;
  let {
    show,
    onHide,
    companyId,
    elster = {},
    startDate = null,
    endDate = null,
    warningMessage,
    showPreviousElsterDates,
    afterSubmitActions,
    createElsterAction,
    updateElsterAction
  } = _ref2;
  const {
    t
  } = useTranslation();
  const [payload, setPayload] = useState({
    id: elster.id,
    start_date: startDate,
    end_date: endDate,
    version_number: (_elster$version_numbe = elster.version_number) !== null && _elster$version_numbe !== void 0 ? _elster$version_numbe : getRecommendedElsterVersionNumber({
      endDate: endDate
    })
  });
  const {
    updateElster
  } = elsterService.useCrud(companyId);
  const changePayload = (key, value) => {
    setPayload(_objectSpread(_objectSpread({}, payload), {}, {
      [key]: value
    }));
  };
  const setEndDatePayload = endDate => {
    setPayload(prev => _objectSpread(_objectSpread({}, prev), {}, {
      end_date: endDate
    }, !(elster !== null && elster !== void 0 && elster.id) && endDate ? {
      version_number: getRecommendedElsterVersionNumber({
        endDate: endDate
      })
    } : {}));
  };
  const body = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement("h2", null, t('enter_dates_for_financial_year')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(DatePicker, {
    "data-testid": "financial_year_modal_start_date",
    onChange: dateValue => changePayload('start_date', dateValue),
    selected: payload.start_date
  })), /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(DatePicker, {
    "data-testid": "financial_year_modal_end_date",
    onChange: setEndDatePayload,
    selected: payload.end_date
  }))), !(elster !== null && elster !== void 0 && elster.id) && /*#__PURE__*/React.createElement(Row, {
    className: "my-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(Dropdown, {
    name: "version_number",
    fieldName: "version_number",
    label: "version_number",
    value: payload.version_number,
    onChange: val => changePayload('version_number', val),
    options: [{
      key: 'version_7',
      value: 'version_7',
      text: 'version_7'
    }, {
      key: 'version_8',
      value: 'version_8',
      text: 'version_8'
    }],
    dataTestId: "financial_year_modal_version_number",
    showNullOption: false,
    labelColSpan: 5,
    dropdownStyle: {
      minWidth: '100%'
    }
  }), payload.end_date && /*#__PURE__*/React.createElement(Form.Text, {
    className: "text-muted"
  }, getRecommendedElsterVersionNumber({
    endDate: payload.end_date
  }) === 'version_7' ? t('end_date_is_before_01_01_2024_version_7_is_recommended') : t('end_date_is_on_or_after_01_01_2024_version_8_is_recommended')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, !payload.start_date || !payload.end_date || !datesInChronologicalOrder(payload.start_date, payload.end_date, 'dd/mm/yyyy', true) ? /*#__PURE__*/React.createElement("p", {
    className: "text-danger"
  }, t('enter_dates_and_make_sure_start_date_is_before_end_date')) : /*#__PURE__*/React.createElement("p", null, t('dates_correct_you_can_submit')))), warningMessage && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: "text-warning"
  }, warningMessage))), showPreviousElsterDates && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", null, "".concat(t('start_date_changing'), ": ").concat(startDate, " >> ").concat(payload.start_date)), /*#__PURE__*/React.createElement("p", null, "".concat(t('end_date_changing'), ": ").concat(endDate, " >> ").concat(payload.end_date)))));
  const updateAction = async () => {
    if (updateElsterAction) {
      await updateElsterAction(_objectSpread({}, payload));
    } else {
      await updateElster(_objectSpread({}, payload));
    }
    afterSubmitActions && (await afterSubmitActions());
  };
  const createAction = async () => {
    await createElsterAction(payload);
    afterSubmitActions && (await afterSubmitActions());
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    size: "lg",
    title: t('add_financial_year'),
    renderBody: () => body,
    onHide: onHide,
    onSubmit: () => elster !== null && elster !== void 0 && elster.id ? updateAction() : createAction(),
    disabled: !payload.start_date || !payload.end_date || !datesInChronologicalOrder(payload.start_date, payload.end_date, 'dd/mm/yyyy', true),
    removeAllAlerts: true,
    submitText: t('save'),
    closeText: t('cancel'),
    centered: false
  });
};
export default FinancialYearModal;